module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-character__validate"
  }, [(_vm.getPlayer) ? _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Félicitations " + _vm._s(_vm.getPlayer.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getPlayer.img,
      "alt": _vm.getPlayer.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "choice-character__validate-sentences"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPlayer.validate['1'])
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPlayer.validate['2'])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "choice-character__validate-action"
  }, [_c('router-link', {
    staticClass: "validate-action-back btn",
    attrs: {
      "to": "choisir-son-personnage-slide"
    }
  }, [_c('span'), _vm._v(" Changer de joueur\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "validate-action-continue btn",
    attrs: {
      "to": "jeu"
    }
  }, [_vm._v("\n        Commencer l'aventure\n      ")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5e6a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/choice-character/ChoiceCharacterValidate.vue
// module id = 79
// module chunks = 0